export const BCRYPT_SALT_CONSTANT = 'BCRYPT_SALT'
